export default "__VITE_ASSET__LXNMkC15__"